angular.module('quattro.bmbo.login.password-reset', [
    'quattro.core.hpls_api_1',
    'quattro.core.form-helper.checkval'
])
    .controller('BmboPasswordResetController', function (api) {

        this.sent = false;

        this.reset = function () {

            // FIXME: add api call
            // this.email

            this.sent = true;
        };
    });
